import { Theme } from '@mui/material';
import { darkTheme } from './dark';
import { lightTheme } from './light';

export const themes: { [key: string]: Theme } = {
    dark: darkTheme,
    light: lightTheme,
};